import SchoolNationality from './SchoolNationality'


export default SchoolNationality
